<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="collapsable-header">
          <div class="bold mb">Passwort</div>
          <div class="">Ändere dein Passwort</div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="settings-collapsable-inner">
          <div class="settings-collapsable-left">
            <div class="input-text-wrapper">
              <label for="password-old" class="input-label"
                >Aktuelles Passwort</label
              >

              <input
                id="password-old"
                placeholder="******"
                type="password"
                class="input-text input-text-border"
                name="password-old"
                required
                autocomplete="current-password"
                v-model="current"
              />
            </div>
            <div class="input-text-wrapper">
              <label for="password" class="input-label">Neues Passwort</label>

              <input
                id="password"
                type="password"
                placeholder="******"
                class="input-text input-text-border"
                name="password"
                required
                autocomplete="new-password"
                v-model="password"
              />
            </div>
            <div class="input-text-wrapper no-m">
              <label for="password-confirm" class="input-label"
                >Neues Passwort wiederholen</label
              >

              <input
                id="password-confirm"
                type="password"
                placeholder="******"
                class="input-text input-text-border"
                name="password-confirm"
                required
                autocomplete="new-password"
                v-model="password_confirmation"
              />
            </div>
          </div>
          <div class="settings-collapsable-right">
            <div class="err-succ-messages">
              <div class="success-message">
                {{ successMessage }}
              </div>
              <div class="error-message">
                {{ errorMessage }}
              </div>
            </div>
            <button @click.prevent="changePassword()" class="btn btn-blue">
              Passwort ändern
            </button>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: [""],
  data() {
    return {
      current: "",
      password: "",
      password_confirmation: "",
      errorMessage: null,
      successMessage: null,
    };
  },
  watch: {},
  methods: {
    changePassword() {
      this.errorMessage = null;
      this.successMessage = null;
      axios
        .post("/changePassword", {
          current: this.current,
          password: this.password,
          password_confirmation: this.password_confirmation,
        })
        .then((res) => {
          this.successMessage = "Dein Passwort wurde erfolgreich geändert.";
          this.current = "";
          this.password = "";
          this.password_confirmation = "";
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.errorMessage = "Das aktuelle Passwort ist nicht korrekt.";
          } else if (error.response.status === 422) {
            this.errorMessage = error.response.data.errors.password[0];
          }
        });
    },
  },
  mounted() {},
  created() {},
  computed: {},
};
</script>

<style>
</style>
